import { FadeInLetteringEffect } from '../effects/fade-in-lettering-effect/fade-in-lettering-effect';
import { FadeEffect } from "../effects/fade-effect/fade-effect";
import { BasicEffect } from "../effects/basic-effect/basic-effect";
import { HoverWorkEffect } from "../effects/hover-work-effect/hover-work-effect";
import { Splide } from "@splidejs/splide";
import { ScrollTo } from "../components/scroll-to/scroll-to";



/**
 *
 * Ciclo di vita
 *
 * 1. Setup
 * 2. Page Ready Event
 * 3. Hide Loader
 *
 */

export class Page {

	pageTitle: string;
	debug: boolean;

	page: HTMLElement;

	basicEffectObserver: IntersectionObserver;
	fadeEffectObserver: IntersectionObserver;
	fadeInLetteringEffectObserver: IntersectionObserver;

	constructor() {
		this.debug = true;
		this.page = document.querySelector('main');
	}


	pageSetup() {

		if ( this.page.querySelector('.scroll-to') ) {
			document.querySelectorAll('.scroll-to').forEach( (el: HTMLElement) => new ScrollTo(el) );
		}

		if ( this.page.querySelector('.scale-up-image') ) {
			import('../components/scale-up-image/scale-up-image').then( c => {
				this.page.querySelectorAll('.scale-up-image').forEach( (el: HTMLElement) => new c.ScaleUpImage(el) );
			});
		}

		if ( this.page.querySelector('.parallax-stripe') ) {
			import('../components/parallax-stripe/parallax-stripe').then( c => {
				this.page.querySelectorAll('.parallax-stripe').forEach( (el: HTMLElement) => new c.ParallaxStripe(el) );
			});
		}

		if (this.page.querySelector('.read-more-block')) {
			import('../components/read-more/read-more').then( c => {
				this.page.querySelectorAll('.read-more-block').forEach( (el: HTMLElement) => new c.ReadMore(el) );
			});
		}

		if ( this.page.querySelector('.custom-cursor') ) {
			import('../components/custom-cursor/custom-cursor').then( c => {
				this.page.querySelectorAll('.custom-cursor').forEach( el => new c.CustomCursor(<HTMLElement>el.parentNode) );
			});
		}

		if ( this.page.querySelector('.work-nav-buttons') ) {
			import('../components/work-nav-buttons/work-nav-buttons').then( c => {
				new c.WorkNavButtons( this.page.querySelector('.work-nav-buttons') );
			});
		}

		if ( this.page.querySelector('.accordion') ) {
			import('../components/accordion/accordion').then( c => {
				new c.Accordion( this.page.querySelector('.accordion') );
			});
		}

		if ( this.page.querySelector('.select-tabs') ) {
			import('../components/select-tabs/select-tabs').then( c => {
				this.page.querySelectorAll('.select-tabs').forEach( (el: HTMLElement) => new c.SelectTabs(el) );
			});
		}

		if ( this.page.querySelector('.gallery-tabs') ) {
			import('../components/gallery-tabs/gallery-tabs').then( c => {
				new c.GalleryTabs( this.page.querySelector('.gallery-tabs') )
			});
		}


		if ( this.page.querySelector('.news-carousel') ) {
			import('../components/news-carousel/news-carousel').then( c => new c.NewsCarousel( this.page.querySelector('.news-carousel')) );
		}


		if ( this.page.querySelector('.basic-gallery') ) {
			this.page.querySelectorAll('.basic-gallery').forEach( (gallery: HTMLElement) => {
				new Splide( gallery, { arrows: false } ).mount();
			});
		}

		if ( this.page.querySelector('.fullscreen-gallery') ) {
			this.page.querySelectorAll('.fullscreen-gallery').forEach( (gallery: HTMLElement) => {
				new Splide( gallery, {
					arrows: false,
					type: 'loop',
					perPage: 1,
					fixedWidth: 380,
					gap: 20,
					breakpoints: {
						600: {
							fixedWidth: '100%'
						}
					}
				} ).mount();
			});
		}

		this.basicEffectObserver = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if ( entry.isIntersecting ) {
					new BasicEffect( <HTMLElement>entry.target );
				}
			});
		}, { threshold: .5 });

		this.fadeEffectObserver = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if ( entry.isIntersecting ) {
					new FadeEffect( <HTMLElement>entry.target );
				}
			});
		}, { threshold: .5 });

		this.fadeInLetteringEffectObserver = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if ( entry.isIntersecting && !entry.target.classList.contains('animation-done') ) {
						new FadeInLetteringEffect( <HTMLElement>entry.target );
					}
				});
			}, { threshold: .5 });

		this.page.querySelectorAll('*[fade-in-lettering-effect]')
			.forEach(target => this.fadeInLetteringEffectObserver.observe(target));

		this.page.querySelectorAll('*[basic-effect]')
			.forEach(target => this.basicEffectObserver.observe(target));

		this.page.querySelectorAll('*[fade-effect]')
			.forEach(target => this.fadeEffectObserver.observe(target));

		this.page.querySelectorAll('*[hover-work-effect]')
			.forEach((link: HTMLElement) => new HoverWorkEffect(link));

	}


	pageReady() {

	}

}
